module.exports = __webpack_public_path__ + "static/media/suite6.890fe040.png";